class FetchUtils {
  static arrayBufferToString(buffer) {
    var uint8 = new Uint8Array(buffer);
    var out = '';
    for (var i = 0, l = uint8.byteLength; i < l; ++i) {
      out += FetchUtils.convertToHex(uint8[i]);
    }
    return FetchUtils.convertToString(out);
  }

  static convertToHex(n) {
    if (n < 16) return '0' + n.toString(16);
    return n.toString(16);
  }

  static convertToString(hexx) {
    var hex = hexx.toString();
    var str = '';
    for (var i = 0; i < hex.length && hex.substr(i, 2) !== '00'; i += 2)
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return str;
  }
}

module.exports = FetchUtils;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/utils/FetchUtils.js